export const SPECIAL_GEMS = [
    {
        iconName: 'IconVerified',
        title: 'Verified apartment listings',
        description: 'Apartments with confirmed availability which you can apply to directly.',
        href: '/listings/status:verified',
        analyticsEvent: 'gems_verified_listings_card',
    },
    {
        iconName: 'IconTopRated',
        title: 'Units in top rated buildings',
        description: 'Buildings that are highly reviewed and rated 4+ stars by past and current renters.',
        href: '/listings/status:top-rated',
        analyticsEvent: 'gems_top_rated_buildings_card',
    },
    {
        iconName: 'IconRentStabilized',
        title: 'Rent-stabilized apartments',
        description: 'Apartments that entitle you to a renewal and limited rent increases.',
        href: '/listings/status:rent-stabilized',
        analyticsEvent: 'gems_rent_stabilized_apartments_card',
    },
];
